import { DownOutlined, ReloadOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  Dropdown,
  Menu,
  notification,
  Input,
  Row,
  Space,
  Timeline,
  Typography,
  Modal,
  Form,
  Tabs,
  Radio,
} from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import API_SERVICE from "shared/services/api-service";
import DocumentationList from "../Documentation/Documentation";
import LenderSelection from "./LenderSelection/LenderSelection";
import LenderLogin from "./LenderLogin/LenderLogin";
import LenderDecision from "./LenderDecision/LenderDecision";
import LenderDisbursed from "./LenderDisbursed/LenderDisbursed";
import AdditionalField from "./AdditionalField/AdditionalField";
import {
  getEnumValue,
  getMaskedMobile,
  getUserDetails,
  hasUserRole,
  numberWithCommas,
} from "shared/services/Utility";
import {ReactComponent as IconShare} from "../../../assets/images/shareIcon.svg";
import whatsappIcon from "../../../assets/images/whatsappIcon.svg";
import homeBlack from "../../../assets/images/home-black.svg";
import RequiredDocuments from "./RequiredDocuments/RequiredDocuments";
import ApplicantInformation from "./ApplicantInformation/ApplicantInformation";
import {ReactComponent as IconArrowBorder} from "../../../assets/images/arrow_border.svg";
import {ReactComponent as Back_Arrow} from "../../../assets/images/back_arrow.svg";
import MultiLenderOfferScreen from "./AdditionalField/MultiLenderOfferScreen";
import LeadDetailNew from "../LeadNew/LeadDetail/LeadDetailNew";
import { useDispatch, useSelector } from "react-redux";
import { setScreenHeader } from "shared/redux/common-reducer";
import GetBureau from "./GetBureau";
import { RootState } from "shared/redux/store";
import { setIsLenderDecisionErr } from "shared/redux/lead-reducer";
import AppLoading from "../AppLoading/AppLoading";
import { useLocation } from "react-router-dom";

const { TextArea } = Input;
const { Text } = Typography;
const { Title } = Typography;
type Props = {};

const LeadDetails: React.FunctionComponent<Props> = () => {
  let { id } = useParams() as any;
  const userRolePermission = hasUserRole();
  const [isModalWhatsappVisible, setIsModalWhatsappVisible] = useState(false);
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [hidePage, setHidePage] = useState(true);
  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [leadData, setLeadData] = useState(null as any);
  const [breDetails, setBreDeatils] = useState({} as any);
  const [isSuccessModalVisible, setIsSuccessModalVisible] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [basicOfferDetails, setBasicOfferDetails] = useState({} as any);
  const [leadHistory, setLeadHistory] = useState(null as any);
  const [userComment, setUserComment] = useState(null as any);
  const [userProspectComment, setUserProspectComment] = useState(null as any);
  const [lenderStatus, setLenderStatus] = useState([] as any);
  const [caseStatus, setCaseStatus] = useState([] as any);
  const [selectedLenderList, setSelectedLenderList] = useState([] as any);
  const [activeLogin, setActiveLogin] = useState(false);
  const [lenderSelection, setLenderSelection] = useState(false);
  const [landerDecisionActive, setLanderDecisionActive] = useState(false);
  const [disbursedActive, setDisbursedActive] = useState(false);
  const [currentStageIndex, setCurrentStageIndex] = useState("prospect");
  const [closeCase, setCloseCase] = useState(false);
  const [loadingCloseCase, setLoadingCloseCase] = useState(false);
  const [activePanel, setActivePanel] = useState("1");
  const [showAdditionalFields, setShowAdditionalFields] = useState(false);
  const [showRequirementDocs, setShowRequirementDocs] = useState(false);
  const [additionalFields, setAdditionalFields] = useState([]);
  const [formData, setFormData] = useState({});
  const [selectedLander, setSelectedLander] = useState<any>({});
  const [callbackAdditionalField, setCallbackAdditionalField] = useState({});
  const [callbackReqDoc, setCallbackReqDoc] = useState({});
  const [faircentStatus, setFaircentStatus] = useState("");
  const [tentativePayout, setTentativePayout] = useState(0);
  const [payoutType, setPayoutType] = useState("");
  const [rejectReasons, setRejectReasons] = useState([] as any);
  const [lenderDetailFibe, setLenderDetailFibe] = useState([] as any);
  const [selectedRejectReasonsKey, setSelectedRejectReasonsKey] = useState(
    null as any
  );
  const [selectedRejectReasons, setSelectedRejectReasons] = useState(
    null as any
  );
  const [selectedCurrentStage, setSelectedCurrentStage] = useState({} as any);
  const [propertyOwnership, setPropertyOwnership] = useState([] as any);
  const [businessProfile, setBusinessProfile] = useState([] as any);
  const [lenderDetailEarlySalary, setLenderDetailEarlySalary] = useState(
    {} as any
  );
  const [taskDetails, setTaskDetails] = useState({
    taskId: "",
    taskDefinitionKey: "",
    taskName: "",
  });
  const [customUI, setCustomUI] = useState(false);
  const [showV2LeadDetails, setShowV2LeadDetails] = useState(false);
  const [bureauScoreStatus, setBureauScoreStatus] = useState("");
  const [consetObj, setConsentObj] = useState({} as any);
  const [bureauColor, setBureauColor] = useState("");
  const [isApplicantModal, setIsApplicantModal] = useState(false);
  const [showApplicantInfo, setShowApplicantInfo] = useState(false);
  const [showMultilenderOffer, setShowMultiLenderOffer] = useState(false);
  const [currLenderId, setCurrLenderId] = useState("");
  const [currLeadId, setCurrLeadId] = useState("");
  const [currLoanProductId, setCurrLoanProductId] = useState("");
    
  const [currentStage, setCurrentStage] = useState({
    visit: false,
    documentation: false,
    lenderSelection: false,
    login: false,
    lenderDecision: false,
    disbursed: false,
    prospect: true,
  });
  const [isLastTask, setIsLastTask] = useState(false);
  const [lenderDetailCashe, setLenderDetailCashe] = useState([] as any);
  const showVas =
    leadData?.applicationSubTypeKey == "SOLE_PROPRIETOR" ||
    leadData?.applicationTypeKey == "INDIVIDUAL";
  const dispatch = useDispatch();
  const {appColors, isMobile}: any = useSelector((state: RootState) => state.common);
  const { tenantInfo }: any = useSelector((state: RootState) => state.tenant);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const number = queryParams.get('number')
  const [getTaskData, setGetTaskData] = useState({} as any);
  const [productWorkflowConfig, setProductWorkflowConfig] = useState({} as any);
    
    
  const getPropertyOwnership = () => {
    let value = {} as any;
    value = propertyOwnership?.find((item: any) => {
      return item?.key === leadData?.caseDetails?.propertyOwnership;
    });
    return value?.value ? value?.value : "NA";
  };

  const getBusinessProfile = () => {
    let value = {} as any;
    value = businessProfile?.find((item: any) => {
      return item?.key === leadData?.businessProfile;
    });
    return value?.value ? value?.value : "NA";
  };

  if (!id) {
    history.goBack();
  }
  useEffect(() => {
    dispatch(
      setScreenHeader({
        backScreenTitle: "Lead",
        backScreenPath: "/lead",
        screenTitle: "View Lead",
      })
    );

    let enumValues = localStorage.getItem("enumValues") as any;
    if (enumValues) {
      enumValues = JSON.parse(enumValues);
      const lenderStatusList = enumValues.find(
        (item) => item.propertyName === "LENDER_STATUS"
      );
      const caseStatusList = enumValues.find(
        (item) => item.propertyName === "CASE_STATUS"
      );
      const rejectedReasonList = enumValues.find(
        (item) => item.propertyName === "REJECTION_REASON"
      );
      const displayRejectedList =
        rejectedReasonList?.keyAndDisplayValueList?.filter((item: any) => {
          return (
            item?.key != "LOAN_SIZE_TOO_LARGE" &&
            item?.key != "INTEREST_RATE_MISMATCH" &&
            item?.key != "NOT_INTERESTED" &&
            item?.key != "NOT_CONTACTABLE" &&
            item?.key != "MISSING_INFORMATION" &&
            item?.key != "LOAN_CANCELED" &&
            item?.key != "LOAN_PRODUCT_NOT_SUPPORTED" &&
            item?.key != "TECHNICAL_ERROR"
          );
        });
      const propertyOwnership = enumValues.find(
        (item) => item.propertyName === "PROPERTY_OWNERSHIP"
      );
      const businessProfileValue = enumValues.find(
        (item: any) => item.propertyName == "BUSINESS_PROFILE"
      );
      setRejectReasons(displayRejectedList);
      setLenderStatus(lenderStatusList);
      setCaseStatus(caseStatusList);
      setPropertyOwnership(propertyOwnership?.keyAndDisplayValueList);
      setBusinessProfile(businessProfileValue?.keyAndDisplayValueList);
    }
    if(number){
      getUpdateTeleCallerId(id, number)
      queryParams.delete(number)
      if(window.location.href.includes("cust360")) {
        history.push("/lead/details/"+id+"/cust360");
      } else {
        history.push("/lead/details/"+id);
      }
    }
    else{
      getLeadById(true);
      getBasicOfferByCaseId();
    }   
  }, []);

  useEffect(() => {}, [userComment, userProspectComment]);

  const setSortingHistory = (leadHistory) => {
    let history: any = [];
    for (let key in leadHistory) {
      history = [...history, ...leadHistory[key]];
    }
    const sortedHistory = history.sort((a, b) =>
      a.statusChangedOn < b.statusChangedOn ? 1 : -1
    );
    setLeadHistory(sortedHistory);
  };

  const getBasicOfferByCaseId = () => {
    setLoading(true);
    API_SERVICE.getBasicOfferByCaseId(id)
      .then(({ data }) => {
        setBreDeatils(data?.payload);
        if (data?.payload?.basicLoanOffer)
          setBasicOfferDetails(data?.payload?.basicLoanOffer);
      })
      .catch((e: any) => {
        notification.error({ message: API_SERVICE.handleErrors(e) });
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const getRedirectURLLink = (
    lenderInfoId,
    loanProductID,
    lenderID,
    copied = false
  ) => {
    const caseId = leadData.caseDetails.caseId;
    API_SERVICE.getCredilioURL(lenderInfoId, loanProductID, lenderID, caseId)
      .then(({ data }) => {
        console.log("data", data);
        if (data) {
          if (data?.payload) {
            const url = data?.payload;
            navigator.clipboard.writeText(data?.payload);
            if (!copied) {
              window.open(url, "_blank")?.focus();
            }
          }
        }
      })
      .catch((e: any) => {
        notification.error({ message: API_SERVICE.handleErrors(e) });
        // setCheckedLeader(true, lenderInfoId);
      });
  };
  const getDownloadLetterForICICI = (lenderID) => {
    const caseId = leadData.caseDetails.caseId;
    API_SERVICE.getSanctionLetterForICICI(lenderID, caseId)
      .then(({ data }) => {
        if (data) {
          if (data?.payload) {
            console.log("Data", data);
            if (data.payload.pdfFile) {
              var a = document.createElement("a") as any;
              document.body.appendChild(a);
              const url = `data:application/pdf;base64,${data.payload.pdfFile}`;
              a.href = url;
              a.download = "ICICISanctionLetter.pdf";
              a.click();
            } else {
              notification.error({ message: data.payload.resDesc });
            }
          }
        }
      })
      .catch((e: any) => {
        notification.error({ message: API_SERVICE.handleErrors(e) });
        // setCheckedLeader(true, lenderInfoId);
      });
  };
  const getCashETriggerSMSLink = (lenderID) => {
    const caseId = leadData.caseDetails.caseId;
    API_SERVICE.sendCashESMSLink(lenderID, caseId)
      .then(({ data }) => {
        console.log("data", data);
        if (data) {
          if (data?.payload) {
            console.log("SMS Triggered", data?.payload);
            // const url = data?.payload;
            // navigator.clipboard.writeText(data?.payload)
            // if (!copied) {
            //   window.open(url, '_blank')?.focus();
            // }
          }
        }
      })
      .catch((e: any) => {
        notification.error({ message: API_SERVICE.handleErrors(e) });
        // setCheckedLeader(true, lenderInfoId);
      });
  };

  const getUpdateTeleCallerId = (id:any, number: any) =>{
    setLoading(true);
    API_SERVICE.getUpdateTeleCallerId(id, number)
    .then(({data}) => {
       if (data?.statusCode === 200){
        notification.success({message:data?.payload})
      }
      getLeadById(true);
      getBasicOfferByCaseId();
    })
    .catch((e: any) => {
      notification.error({ message: API_SERVICE.handleErrors(e) });
      getLeadById(true);
      getBasicOfferByCaseId();
    });
    
  }

  const getLeadById = (setStatus?, status = "") => {
    setLoading(true);
    API_SERVICE.getLeadsById(id)
      .then(({ data }) => {
        if (data?.payload) {
          setUserProspectComment(
            data?.payload?.caseDetails?.caseHistoryHolder?.prospectState?.at(0)?.comments
          );
          // setUserComment(data?.payload?.caseDetails?.caseHistoryHolder?.prospectState[0]?.comments);
        }
        if (data?.payload) {
          setLeadData(data.payload);
          if (
            data.payload.caseDetails?.documentDetails?.length > 0 &&
            data.payload.caseDetails?.lenderActivityHolder
              ?.lenderActivityDetails?.length > 0
          ) {
            setActiveLogin(true);
          }
          if (data?.payload?.caseDetails?.caseHistoryHolder) {
            setSortingHistory(data.payload.caseDetails.caseHistoryHolder);
          }
          if (
            data.payload.caseDetails.lenderActivityHolder.lenderActivityDetails
              .length > 0
          ) {
            data.payload.caseDetails.lenderActivityHolder.lenderActivityDetails.map(
              (item) => {
                item.rmName = item?.rmName ? item.rmName : "";
                item.openInput = false;
              }
            );
            const lenderInfofibe =
              data.payload.caseDetails.lenderActivityHolder.lenderActivityDetails.filter(
                (item) => {
                  return item.lenderName.toLowerCase().includes("fibe");
                }
              );
            const lenderInfoCashe =
              data.payload.caseDetails.lenderActivityHolder.lenderActivityDetails.filter(
                (item) => {
                  return item.lenderName.toLowerCase().includes("cashe");
                }
              );
            const lenderInfoEarlySalary = lenderInfofibe?.map(
              (item) => item.earlySalaryResponseDetails
            );
            if (lenderInfoEarlySalary.length > 0) {
              setLenderDetailEarlySalary(lenderInfoEarlySalary[0]);
            }

            // earlySalaryResponseDetails

            setLenderDetailFibe(lenderInfofibe);
            setLenderDetailCashe(lenderInfoCashe);
            setSelectedLenderList(
              data.payload.caseDetails.lenderActivityHolder
                .lenderActivityDetails
            );
            // if (status === 'disbursed') {
            //   getDisbursed(data.payload.caseDetails.lenderActivityHolder
            //     .lenderActivityDetails);
            // }
          }
          if (setStatus) {
            const caseStatus = data?.payload?.caseDetails?.caseStatus;
            setCurrentState(caseStatus);
            const upperCaseFirstLetter = `${caseStatus
              .slice(0, 1)
              .toLowerCase()}${caseStatus.slice(1)}`;
            let stage = upperCaseFirstLetter?.replace(" ", "");
            stage = stage === "logged" ? "login" : stage;
            setCurrentStageIndex(stage);
          }

          const payoutType =
            data?.payload?.caseDetails?.connectorDetails?.payoutType ?? "";
          const payoutPercentage =
            data?.payload?.caseDetails?.connectorDetails?.payoutPercentage ?? 0;
          const interestRate =
            data?.payload?.caseDetails?.loanDetails?.expectedInterestRate ?? 0;
          const tmpPayout =
            payoutType === "FIXED" ? payoutPercentage : interestRate;
          const caseStatus = data?.payload?.caseDetails?.caseStatus ?? "";

          setSelectedRejectReasonsKey(
            data?.payload?.caseDetails?.rejectionReason
          );
          setPayoutType(payoutType);
          setTentativePayout(tmpPayout);

          // TODO - Bureau Score
          // if (
          //   !isShowedAdditionalFields && (payoutType.length ?? 0) != 0 &&
          //   ((tmpPayout == 0) || ((data?.payload?.leadAdditionalInfoDetails?.bureauScoreStatus?.length ?? 0) == 0))
          // ) {

          // if (
          //   !isShowedAdditionalFields && (payoutType.length ?? 0) !== 0 &&
          //   payoutType === "VARIABLE" && tmpPayout === 0 &&
          //   (caseStatus === "Documentation"|| caseStatus === "visit")
          // ) {
          //   setIsShowedAdditionalFields(true);
          //   setShowAdditionalFields(true);
          // }
        }
        if (data?.payload?.productVersion == "V2") {
          if (data?.payload?.processInstanceId) {
            setShowV2LeadDetails(true);
          } else {
            notification.error({
              message: "Process Instance Id Not Available",
            });
          }
        }
        if (data?.payload?.productVersion === "V2_NO_FLOWABLE")
          {
            let processInstanceId = data?.payload?.processInstanceId
            const params = {
              caseId : data?.payload?.caseDetails?.caseId,
              loanProductId : data?.payload?.loanProductId
          }
          API_SERVICE.updateLoanProductandStartFlowable(params)
          .then(({ data }) => {
            getLeadById()
          })
        }
      })
      
      .catch((e: any) => {
        notification.error({ message: API_SERVICE.handleErrors(e) });
      })
      .finally(() => {
        setLoading(false);
        setHidePage(false);
      });
  };

  
  const setCurrentState = (status) => {
    console.log("status", status);
    const currentStageCopy = { ...currentStage } as any;
    if (status === "Lead") {
      setLenderSelection(true);
      setCurrentStage({
        ...currentStageCopy,
        prospect: true,
      });
    }
    if (status === "Visit") {
      setCurrentStage({
        ...currentStageCopy,
        visit: true,
        prospect: false,
      });
      setActivePanel("1");
    }
    if (status === "Documentation") {
      setCurrentStage({
        ...currentStageCopy,
        prospect: true,
      });
      setActivePanel("2");
    }
    if (status === "Lender Selection") {
      setActiveLogin(true);
      setCurrentStage({
        ...currentStageCopy,
        prospect: false,
        lenderSelection: true,
      });
    }
    if (status === "Logged") {
      setLanderDecisionActive(true);
      setActiveLogin(true);
      setCurrentStage({
        ...currentStageCopy,
        prospect: false,
        login: true,
      });
    }
    if (status === "Lender Decision") {
      setDisbursedActive(true);
      setLanderDecisionActive(true);
      setActiveLogin(true);
      setCurrentStage({
        ...currentStageCopy,
        prospect: false,
        lenderDecision: true,
      });
    }
    if (status === "Disbursed") {
      setDisbursedActive(true);
      setLanderDecisionActive(true);
      setActiveLogin(true);
      setCurrentStage({
        ...currentStageCopy,
        prospect: false,
        disbursed: true,
      });
    }
    if (status === "Prospect") {
      setCurrentStage({
        ...currentStageCopy,
        visit: false,
        prospect: true,
      });
    }
  };

  const onClickMenu = (ev: any) => {
    setSelectedCurrentStage(currentStage);
    setCurrentStageIndex(ev.key);

    if (ev.key === "documentation") {
      const currentStageCopy = { ...currentStage } as any;
      setCurrentStage({
        ...currentStageCopy,
        [ev.key]: true,
      });
      setActivePanel("2");
    } else {
      const currentStageCopy = { ...currentStage } as any;
      for (var key in currentStageCopy) {
        if (currentStageCopy.hasOwnProperty(key)) {
          currentStageCopy[key] = false;
        }
      }
      setCurrentStage({
        ...currentStageCopy,
        [ev.key]: true,
      });
      setActivePanel("1");
    }
  };
  const menuList = (
    <Menu
      selectable
      selectedKeys={[currentStageIndex]}
      className="menu-list"
      style={{'--bgColor': appColors?.appPrimaryLightColor ?? '','--color': appColors?.appPrimaryColor ?? ''}as any}
      onClick={onClickMenu}
      items={[
        {
          key: "prospect",
          label: "Prospect",
        },
        {
          key: "visit",
          label: "Visit",
        },
        {
          key: "documentation",
          label: "Documentation",
          disabled: false,
        },
        {
          key: "lenderSelection",
          label: "Lender Selection",
          disabled: false,
        },
        {
          key: "login",
          label: "Log in",
          disabled: !activeLogin,
        },
        {
          key: "lenderDecision",
          label: "Lender Decision",
          disabled: !landerDecisionActive,
        },
        {
          key: "disbursed",
          label: "Disbursed",
          disabled: !disbursedActive,
        },
      ]}
    />
  );

  const nextStage = (stageName) => {
    setCurrentStageIndex(stageName.toString());
    if (stageName === "VISIT") {
      // if (currentStageIndex === "prospect") {
      setCurrentStageIndex(stageName.toLowerCase().toString());
      setActivePanel("2");
      setCurrentState("Visit");
      // }
      return;
    }
    if (stageName === "DOCUMENTATION") {
      setCurrentStageIndex(stageName.toLowerCase().toString());
      setActivePanel("2");
      return;
    }
    if (stageName === "DISBURSED") {
      history.push("/lead");
      return;
    }

    const currentStageCopy = { ...currentStage } as any;
    for (var key in currentStageCopy) {
      if (currentStageCopy.hasOwnProperty(key)) {
        currentStageCopy[key] = false;
      }
    }
    setTimeout(() => {
      setCurrentStage({
        ...currentStageCopy,
        [stageName]: true,
      });
      setLoadingUpdate(false);
    }, 1000);
  };

  const visitNextHandler = () => {
    let data = {
      comments:
        userComment ??
        leadData?.caseDetails?.caseHistoryHolder?.visitState[0]?.comments,
      status: "VISIT",
    };

    API_SERVICE.closeCase(leadData.caseDetails.caseId, data)
      .then(({ data }) => {
        if (data) {
          notification.success({ message: data.message });
          getLeadById();
          setUserComment(null);
          setTimeout(() => {
            nextStage("DOCUMENTATION");
          });
        }
      })
      .catch((e: any) => {
        notification.error({ message: API_SERVICE.handleErrors(e) });
      });
  };

  const prospectSubmitHandler = () => {
    let data = {
      comments: userProspectComment,
      status: "PROSPECT",
    };

    if (!userProspectComment) {
      setUserProspectComment(
        leadData?.caseDetails?.caseHistoryHolder?.prospectState[0]?.comments
      );
      nextStage("VISIT");
      return;
    }

    if (
      leadData?.caseDetails?.caseHistoryHolder?.prospectState[0]?.comments ===
      userProspectComment
    ) {
      nextStage("VISIT");
      return;
    }

    API_SERVICE.closeCase(leadData.caseDetails.caseId, data)
      .then(({ data }) => {
        if (data) {
          notification.success({ message: data.message });
          getLeadById();
          setTimeout(() => {
            nextStage("VISIT");
          });
          // setUserComment(null);
          setUserProspectComment(null);
        }
      })
      .catch((e: any) => {
        notification.error({ message: API_SERVICE.handleErrors(e) });
      });
  };

  const lenderNextHandler = (lenderData) => {
    let cStatus = caseStatus?.keyAndDisplayValueList.find(
      (item) => item.key === "LENDER_SELECTION"
    );
    let lStatusAssigned = lenderStatus.keyAndDisplayValueList.find(
      (item) => item.key === "ASSIGNED"
    );
    let lStatusUnAssigned = lenderStatus.keyAndDisplayValueList.find(
      (item) => item.key === "UNASSIGNED"
    );

    let defaultLender =
      leadData?.caseDetails?.lenderActivityHolder?.lenderActivityDetails?.map(
        (item) => item.branchName
      );
    let selectedL = lenderData?.selectedLenders?.map((item) => item.branchName);
    let tempArr = [] as any;
    defaultLender?.filter((dItem) => {
      if (!selectedL.includes(dItem)) {
        tempArr.push(dItem);
      }
    });
    const unAssignLender =
      leadData?.caseDetails?.lenderActivityHolder?.lenderActivityDetails?.filter(
        (item) => tempArr.includes(item.branchName)
      );
    const lenderDetails = [] as any;
    if (lenderData?.update) {
      lenderData.selectedLenders.forEach((item: any) => {
        lenderDetails.push({
          lenderInfoId: item.lenderInfoId,
          lenderName: item.lenderName,
          status: item.status ?? lStatusAssigned.key,
          branchName: item.branchName,
          hubName: item.hubName,
          submissionType: item.submissionType,
        });
      });
      if (unAssignLender.length > 0) {
        unAssignLender.map((item) => {
          lenderDetails.push({
            lenderInfoId: item.lenderInfoId,
            lenderName: item.lenderName,
            status: item.status ?? lStatusUnAssigned.key,
            branchName: item.branchName,
            hubName: item.hubName,
            submissionType: item.submissionType,
          });
        });
      }
    } else {
      lenderData.selectedLenders.forEach((item: any) => {
        lenderDetails.push({
          lenderInfoId: item.lenderInfoId,
          lenderName: item.lenderName,
          status: item.status ?? lStatusAssigned.key,
          branchName: item.branchName,
          hubName: item.hubName,
          submissionType: item.submissionType,
        });
      });
    }

    let lendersData = [] as any;
    leadData?.caseDetails?.lenderActivityHolder?.lenderActivityDetails?.map(
      (pItem) => {
        lenderDetails.map((cItem) => {
          if (
            pItem.status === "ASSIGNED" &&
            pItem.lenderInfoId === cItem.lenderInfoId
          ) {
            lendersData.push(cItem);
          }
          if (
            pItem.status !== "LOGGED" &&
            pItem.lenderInfoId === cItem.lenderInfoId
          ) {
            lendersData.push(cItem);
          }
        });
      }
    );

    lenderData.selectedLenders.map((pItem) => {
      let lender =
        leadData?.caseDetails?.lenderActivityHolder?.lenderActivityDetails?.find(
          (lItem) => lItem.lenderInfoId === pItem.lenderInfoId
        );
      if (!lender) {
        lendersData.push({
          lenderInfoId: pItem.lenderInfoId,
          lenderName: pItem.lenderName,
          status: pItem.status ?? lStatusAssigned.key,
          branchName: pItem.branchName,
          hubName: pItem.hubName,
          submissionType: pItem.submissionType,
        });
      }
    });

    const tmpLendersData = Array.from(new Set(lendersData)) as any;

    console.log("lendersData: ", lendersData);
    console.log("tmpLendersData: ", tmpLendersData);

    const payload = {
      comments: lenderData.comment,
      lenderDetails: tmpLendersData.length > 0 ? tmpLendersData : lenderDetails,
    };
    updateCase(payload, cStatus, "login");
    setActiveLogin(true);
  };

  const updateCase = (payload, status, nextStep?, callBack?) => {
    if ((payload?.lenderDetails?.length ?? 0) == 0) {
      setLoading(false);
      nextStage(nextStep);
      return;
    }

    setLoadingUpdate(true);
    API_SERVICE.updateCase(
      leadData?.caseDetails?.caseId,
      status.key,
      payload,
      leadData?.loanProductId
    )
      .then(({ data }) => {
        if (data) {
          callBack && callBack({success: true});
          notification.success({ message: data.message });
          getLeadById(null, nextStep);
          setTimeout(() => {
            nextStage(nextStep);
            // setLoading(false);
          });
        }
      })
      .catch((e: any) => {    
        notification.error({ message: API_SERVICE.handleErrors(e) });
        dispatch(setIsLenderDecisionErr(status?.key == "LENDER_DECISION"));
        setLoadingUpdate(false);
      });
  };
  const skippedLoginStatus = () => {
    setLanderDecisionActive(true);
    getLeadById();
    nextStage("lenderDecision");
    setLoading(false);
  };

  const lenderLoginHandler = (data: any) => {
    setLoading(true);
    let cStatus = caseStatus.keyAndDisplayValueList.find(
      (item) => item.key === "LOGGED"
    );
    let lStatus = lenderStatus.keyAndDisplayValueList.find(
      (item) => item.key === "LOGGED"
    );
    const lenderDetails = [] as any;
    data.assignedLenderFiltered.forEach((item: any) => {
      let status = lStatus.key;
      if (!["ASSIGNED", "CREATED"].includes(item.status)) {
        status = item.status;
        if (item.status.toLowerCase() === "rejected") {
          cStatus = caseStatus.keyAndDisplayValueList.find((item1) =>
            item1.key.toLowerCase().includes(item.status.toLowerCase())
          );
        }
      }
      lenderDetails.push({
        ...item,
        lenderActivityId: item.lenderActivityId,
        lenderInfoId: item.lenderInfoId,
        lenderName: item.value ?? item.lenderName,
        status: status,
        branchName: item.branchName,
        hubName: item.hubName,
        rmName: item.rmName,
      });
    });
    const payload = {
      comments: data.comment,
      lenderDetails,
    };
    updateCase(payload, { key: tenantInfo?.businessProductType === "INSURANCE" ? "POLICY_LOGGED" : "LOGGED" }, "lenderDecision");
    setLanderDecisionActive(true);
  };

  const lenderDecisionHandler = (params: any, callBack?: any) => {
    const { lenders, comment, requestedAmount, approvedAmount } = params;
    const lenderDetails = [] as any;
    let cStatus = caseStatus.keyAndDisplayValueList.find(
      (item) => item.key === "LENDER_DECISION"
    );
    let lStatusSanctioned = lenderStatus.keyAndDisplayValueList.find(
      (item) => item.key === "SANCTIONED"
    );
    let lStatusRejected = lenderStatus.keyAndDisplayValueList.find(
      (item) => item.key === "REJECTED"
    );
    let lStatusWithdrawn = lenderStatus.keyAndDisplayValueList.find(
      (item) => item.key === "WITHDRAWN"
    );
    let lStatusPendency = lenderStatus.keyAndDisplayValueList.find(
      (item) => item.key === "PENDENCY"
    );
    lenders.map((item: any, i: number) => {
      if (
        item?.leanderDecision?.selectedType === 1 &&
        Object.keys(item?.leanderDecision?.sanctionedData)?.length > 0
      ) {
        lenderDetails.push({
          branchName: item.branchName,
          comments: item.leanderDecision.sanctionedData.comment,
          hubName: item.hubName,
          insuranceAmount: item.insuranceAmount,
          interestRate: item.leanderDecision.sanctionedData.interestRate,
          lenderActivityId: item.lenderActivityId,
          lenderInfoId: item.lenderInfoId,
          lenderName: item.lenderName,
          rmName: item.rmName,
          sanctionedAmount: item.leanderDecision.sanctionedData.loanAmount,
          sanctionedDate: item.leanderDecision.sanctionedData.sanctionedDate,
          status: lStatusSanctioned.key,
        });
      }
      if (
        item?.leanderDecision?.selectedType === 2 &&
        Object.keys(item?.leanderDecision?.rejectedData)?.length > 0
      ) {
        let reasonKey = `rejectReason${i}`;
        let commentKey = `comment${i}`;
        lenderDetails.push({
          rejectedReason: item.leanderDecision.rejectedData[reasonKey],
          lenderProposalStatusDocumentDetails: {documentProofIdsForStatus:[item.leanderDecision.rejectedData[`rejectDocument${i}`]]},
          comments: item.leanderDecision.rejectedData[commentKey],
          status: lStatusRejected.key,
          lenderActivityId: item.lenderActivityId,
          lenderName: item.lenderName,
          lenderInfoId: item.lenderInfoId,
        });
      }
      if (
        item?.leanderDecision?.selectedType === 3 &&
        Object.keys(item?.leanderDecision?.withdrawnData)?.length > 0
      ) {
        let commentKey = `comment${i}`;
        lenderDetails.push({
          comments: item.leanderDecision.withdrawnData[commentKey],
          status: lStatusWithdrawn.key,
          lenderActivityId: item.lenderActivityId,
          lenderName: item.lenderName,
          lenderInfoId: item.lenderInfoId,
          lenderProposalStatusDocumentDetails: {documentProofIdsForStatus:[item.leanderDecision.withdrawnData[`withdrawnDocument${i}`]]},
        });
      }
      if (
        item?.leanderDecision?.selectedType === 4 &&
        Object.keys(item?.leanderDecision?.pendencyData)?.length > 0
      ) {
        let commentKey = `comment${i}`;
        lenderDetails.push({
          comments: item.leanderDecision.pendencyData[commentKey],
          status: lStatusPendency.key,
          lenderActivityId: item.lenderActivityId,
          lenderName: item.lenderName,
          lenderInfoId: item.lenderInfoId,
        });
      }
    });
    const payload = {
      lenderDetails,
      comments: comment,
      requestedAmount,
      approvedAmount,
    };
    updateCase(payload, cStatus, "disbursed", callBack);
    setDisbursedActive(true);
  };
  // const getDisbursed = (lenderValues) => {
  //   lenderValues?.filter((items) => {
  //     let disbursedData = '';
  //     if (items?.disbursalLenderInfoDetails?.length > 0) {
  //       items?.disbursalLenderInfoDetails.filter((disbursedID) => {
  //         disbursedData = disbursedData ? `${disbursedData}, ${disbursedID?.disbursalId}` : `${disbursedID?.disbursalId}`
  //       })
  //       const payload = {
  //         disbursementIds: [
  //           disbursedData
  //         ]
  //       };
  //       API_SERVICE.updateDisbursedStatus(leadData?.caseDetails?.caseId, items?.lenderInfoId, payload).then((res) => {
  //         notification.success({ message: res.data.payload });
  //       }).catch((e: any) => {
  //         notification.error({ message: API_SERVICE.handleErrors(e) });
  //       });
  //     }
  //   });
  // };

  const lenderDisbursedHandler = (values: any) => {
    let lStatusDisbursed = lenderStatus.keyAndDisplayValueList.find(
      (item) => item.key === "DISBURSED"
    );
    let cStatusDisbursed = caseStatus.keyAndDisplayValueList.find(
      (item) => item.key === "DISBURSED"
    );
    let lenderDetails = [] as any;
    values.lenders.map((item) => {
      lenderDetails.push({
        branchName: item.branchName,
        comments: values?.comment ?? "",
        disbursedAmount: item?.disbursedData?.disbursedAmount,
        lenderInfoId: item.lenderInfoId,
        insuranceAmount: item.insuranceAmount,
        hubName: item.hubName,
        lenderActivityId: item.lenderActivityId,
        interestRate: item.interestRate,
        lenderName: item.lenderName,
        rmName: item.rmName,
        sanctionedAmount: item.sanctionedAmount,
        status: lStatusDisbursed.key,
        disbursalLenderInfoEntity: item.disbursalLenderInfoEntity,
        payoutDetails: item.payoutDetails,
        payoutInfoDetails: item.payoutInfoDetails,
        payoutInfoEntities: item.payoutInfoEntities,
      });
    });
    const payload = {
      comments: values?.comment ?? "",
      lenderDetails,
    };
    updateCase(payload, cStatusDisbursed, "disbursed");
  };

  const lenderDocumentHandler = (comment: any) => {
    let data = {
      comments: comment,
      status: "DOCUMENTATION",
    };
    API_SERVICE.closeCase(leadData.caseDetails.caseId, data)
      .then(({ data }) => {
        if (data) {
          notification.success({ message: data.message });
          getLeadById();
          setTimeout(() => {
            nextStage("lenderSelection");
            setCurrentStageIndex("lenderSelection");
            setActivePanel("1");
          });
        }
      })
      .catch((e: any) => {
        notification.error({ message: API_SERVICE.handleErrors(e) });
      });
  };

  const onChangeRejectionReason = (selectedValue) => {
    setSelectedRejectReasonsKey(selectedValue.key);
    setSelectedRejectReasons(selectedValue.value);
  };

  const closeCaseHandler = (value: any) => {
    setLoadingCloseCase(true);
    const caseId = leadData.caseDetails.caseId;
    const closeStatus = caseStatus.keyAndDisplayValueList.find(
      (item) => item.key === "CLOSED"
    );
    const payload = {
      comments: selectedRejectReasons,
      status: closeStatus.key,
      rejectionReason: selectedRejectReasonsKey,
    };
    API_SERVICE.closeCase(caseId, payload)
      .then(({ data }) => {
        if (data) {
          notification.success({ message: data.message });
          setCloseCase(false);
          history.push("/lead");
        }
      })
      .catch((e: any) => {
        notification.error({ message: API_SERVICE.handleErrors(e) });
      })
      .finally(() => {
        setLoadingCloseCase(false);
      });
  };

  const changeStage = (key) => {
    setActivePanel(key);
    if (key == "3") {
      getBureauScore();
    }
  };

  const getBureauScore = (pan?: any) => {
    let panId = pan || leadData?.contactDetails?.pan;
    API_SERVICE.getBureauScore(panId)
      .then(({ data }) => {
        if (data) {
          setBureauScoreStatus(data?.payload?.status);
          setBureauColor(data?.payload?.color);
          setConsentObj(data?.payload?.consent);
        }
      })
      .catch((e: any) => {
        notification.error({ message: API_SERVICE.handleErrors(e) });
      });
  };

  const genrateBureauScore = (pan?: any) => {
    let payload = {
      caseId: leadData?.caseDetails?.caseId,
      panId: pan || leadData?.contactDetails?.pan,
      userId: getUserDetails()?.userId,
    };
    API_SERVICE.genrateBureauScore(payload)
      .then(() => {
        getBureauScore();
      })
      .catch((e: any) => {
        notification.error({ message: API_SERVICE.handleErrors(e) });
      });
  };

  const handleModalOk = () => {
    setIsModalWhatsappVisible(false);
    API_SERVICE.sendWhatsAppMessage(leadData?.caseDetails?.caseId)
      .then(({ data }) => {
        setIsModalWhatsappVisible(false);
        if (data.payload) {
          notification.success({ message: data.payload });
        }
      })
      .catch((e: any) => {
        notification.error({ message: API_SERVICE.handleErrors(e) });
      });
  };

  const handleModalCancel = () => {
    setIsModalWhatsappVisible(false);
  };
  const handleModalmessage = () => {
    setIsSuccessModalVisible(false);
  };

  const whatsapp = () => {
    return (
      <Modal
        centered
        width={450}
        visible={isModalWhatsappVisible}
        footer={null}
        closable={false}
      >
        <div
          style={{
            paddingBottom: "40px",
            paddingTop: "40px",
            paddingLeft: "15px",
            paddingRight: "15px",
          }}
        >
          <p
            style={{
              textAlign: "center",
              marginTop: "10px",
              marginBottom: "35px",
              marginLeft: "5px",
              fontSize: "medium",
            }}
          >
            Is {leadData?.contactDetails?.mobileNumber} the valid contact
            number? <br />
            If not, please update lead details.
          </p>
          <div
            style={{ display: "flex", gap: "10px", justifyContent: "center" }}
          >
            <Button
              className="dynamic-btn-primary"
              style={{'--btnColor': appColors?.appPrimaryColor ?? "",width: "155px", height: "40px", borderRadius: "8px"}as any}
              type="primary"
              onClick={handleModalOk}
            >
              Confirm
            </Button>
            <Button
              className="dynamic-btn-default"
              type="default"
              style={{'--borderColor': appColors?.appSecondaryColor ?? "",width: "155px", height: "40px", borderRadius: "8px"}as any}
              onClick={handleModalCancel}
            >
              Back
            </Button>
          </div>
        </div>
      </Modal>
    );
  };

  const message = () => {
    return (
      <Modal
        centered
        width={450}
        visible={isSuccessModalVisible}
        footer={null}
        closable={false}
      >
        {" "}
        <p
          style={{
            textAlign: "center",
            marginTop: "30px",
            marginBottom: "15px",
            marginLeft: "5px",
            fontSize: "medium",
          }}
        >
          {successMessage}
        </p>
        <Button
          type="default"
          className="dynamic-btn-default"
          style={{'--borderColor': appColors?.appSecondaryColor ?? "",width: "155px", height: "40px", borderRadius: "8px", margin: "20px",marginLeft: "110px"}as any}
          onClick={handleModalmessage}
        >
          OK
        </Button>
      </Modal>
    );
  };

  const handleClick = () => {
    API_SERVICE.getWhatsAppDocumentValidate(leadData?.caseDetails?.caseId)
      .then(({ data }) => {
        if (data.payload.validToSend) {
          setIsModalWhatsappVisible(true);
        } else {
          // notification.error({ message: data.payload.message })
          setSuccessMessage(data.payload.message);
          setIsSuccessModalVisible(true);
        }
      })
      .catch((e: any) => {
        notification.error({ message: API_SERVICE.handleErrors(e) });
      });
  };

  const getShareLinkId = (item: any) => {
    API_SERVICE.getShareLinkId(item?.caseDetails?.caseId)
      .then(({ data }) => {
        navigator.clipboard.writeText(data?.payload);
      })
      .catch((error) => {
        notification.error({ message: error });
      })
      .finally(() => {});
  };

  const getLeadStage = () => {
    const strStage = leadData?.caseDetails?.caseStatus ?? "";
    let stage: any = {
      name: strStage,
      firstChar: strStage[0],
    };
    switch (strStage) {
      case "Lead":
        stage["id"] = 1;
        break;

      case "Visit":
        stage["id"] = 2;
        break;

      case "Documentation":
        stage["id"] = 3;
        break;

      case "Lender Selection":
        stage["id"] = 4;
        break;

      case "Logged":
        stage["id"] = 5;
        break;

      case "Lender Decision":
        stage["id"] = 6;
        break;

      case "Disbursed":
        stage["id"] = 7;
        break;

      case "Closed":
        stage["id"] = 8;
        break;

      case "Prospect":
        stage["id"] = 9;
        break;

      default:
        break;
    }

    return stage;
  };

  const topView = () => {
    const { firstChar, name } = getLeadStage();
    return (
      <div className="top-view">
        <img src={homeBlack} alt="" style={{ height: "25px", width: "25px" }} />
        <div style={{ width: "100%" }}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Text>Loan Type</Text>
            <Text style={{ fontSize: "small" }}>{name}</Text>
          </div>
          <Text className="lead-data-loan-type">{leadData?.loanType}</Text>
        </div>
      </div>
    );
  };

  const renderValue = (key: string, value: any) => {
    if (value != null && typeof value === "object") {
      console.log("object: ", `${key}: ${value}`);
      return renderObj(key, value);
    }

    if (value == null) {
      return <></>;
    }

    console.log("renderValue: ", `${key}: ${value}`);
    return (
      <div>
        {!isNaN(parseInt(key)) ? (
          <Text>{`${value}`}</Text>
        ) : (
          <Text>{`${key}: ${value}`}</Text>
        )}
      </div>
    );
  };

  const renderObj = (title, res) => {
    if (res == null) {
      return <></>;
    }

    // if (typeof res === 'string') {}
    if (["string", "number", "boolean"].includes(typeof res)) {
      const tmpTitle = (title?.length ?? 0) == 0 ? "Response" : title;
      return <div>{renderValue(tmpTitle, res)}</div>;
    }

    // console.log("renderObj: ", title, " --- ", res);
    const data = Object.keys(res);
    return (
      <div>
        <Text style={{ fontWeight: "bold", color: "black" }}> {title} </Text>
        {data?.map((key: any) => {
          let value = res[key];
          if (Array.isArray(value)) {
            value = res[key]?.join(", ");
          }
          return renderValue(key, value);
        })}
      </div>
    );
  };

  const renderStatusupdate = (statusUpdate: any) => {
    console.log("statusUpdate: ", statusUpdate);
    let obj = statusUpdate;
    try {
      if (typeof statusUpdate === "string") {
        obj = JSON.parse(statusUpdate ?? "{}");
      }
    } catch (e) {
      obj = {};
    }

    console.log("obj: ", obj);

    // if (obj?.response) {
    //   let res = obj?.response;
    //   try {
    //     res = JSON.parse(obj?.response ?? "{}");
    //   } catch (error) { }
    //   console.log("res: ", res);
    //   return <div style={{ marginTop: '0px' }}> {renderObj("", res)}  </div>
    // } else {
    const data = Object.keys(obj);
    return (
      <div style={{ marginTop: "0px" }}>
        {data.map((key: any, index: any) => {
          // console.log("key --- : ", key, " -- ", obj[key])
          let res = obj[key];
          try {
            res = JSON.parse(obj?.[key] ?? "{}");
          } catch (error) {}
          return <div key={index}> {renderObj(key, res)} </div>;
        })}
      </div>
    );
    // }

    return <></>;
  };

  const btnDefaultBorderStyle: any = {'--borderColor': appColors?.appSecondaryColor ?? "", display: "grid"};
  const btnPrimaryStyles : any = {'--btnColor' :appColors?.appPrimaryColor ?? ""};
  const tabStyles: any = { '--bgColor': appColors?.appSecondaryLightColor ?? "", marginTop: "0px", '--color': '#fff' };
  const btnRadioStyles: any = { '--borderColor': appColors?.appPrimaryColor ?? "",display: "grid"};

  const renderEducationDetails = () => {
    return (
      <>
        <Space direction="vertical" className="gap">
          <Text className="title">Education Details</Text>
          <Text>
            {"Time of study (Starts from): "}
            {
              leadData?.caseDetails?.loanDetails?.educationLoanDetails
                ?.timeOfStudy
            }
          </Text>
          <Text>
            {"Preferred place of study: "}
            {getEnumValue(
              "PLACE_STUDY",
              leadData?.caseDetails?.loanDetails?.educationLoanDetails
                ?.placeOfStudy ?? ""
            )}
          </Text>
          <Text>
            {"Admission Status: "}
            {getEnumValue(
              "ADMISSION_STATUS",
              leadData?.caseDetails?.loanDetails?.educationLoanDetails
                ?.admissionStatus ?? ""
            )}
          </Text>
        </Space>
      </>
    );
  };
  
  if(hidePage) {
    return <AppLoading />;
  }

  return showV2LeadDetails ? (
    <LeadDetailNew
      leadData={leadData}
      getLeadById={getLeadById}
      setLeadData={setLeadData}
      getCashETriggerSMSLink={getCashETriggerSMSLink}
      getRedirectURLLink={getRedirectURLLink}
      getDownloadLetterForICICI={getDownloadLetterForICICI}
      lenderLoginHandler={lenderLoginHandler}
      lenderDecisionHandler={lenderDecisionHandler}
      lenderNextHandler={lenderNextHandler}
      loading={loadingUpdate}
      getTaskData={getTaskData}
      setGetTaskData={setGetTaskData}
      productWorkflowConfig = {productWorkflowConfig}
      setProductWorkflowConfig={setProductWorkflowConfig}            
    />
  ) : (
    <div className="content-box">
      {closeCase && (
        <Modal
          title="Close Case"
          centered
          width={400}
          onCancel={() => setCloseCase(false)}
          footer={null}
          visible={closeCase}
        >
          <div className="close-case-box">
            <Form
              layout="vertical"
              onFinish={closeCaseHandler}
              initialValues={{ reason: selectedRejectReasonsKey }}
            >
              <Row gutter={[16, 16]}>
                <Col span={24}>
                  {/* <Form.Item
                    name="comments"
                    rules={[
                      { required: true, message: "Please enter comments" },
                    ]}
                  >
                    <TextArea
                      minLength={10}
                      className="custom-textarea"
                      name="comments"
                      placeholder="Comment"
                    />
                  </Form.Item> */}

                  <Form.Item
                    label="Select reason"
                    name="reason"
                    rules={[
                      { required: true, message: "Please enter comments" },
                    ]}
                  >
                    <Radio.Group
                      //style={{ display: "grid" }}
                      className="dynamic-radio"
                      style={btnRadioStyles}
                      name="reason"
                      // onChange={(ev) => onChangeHandler(ev, i)}
                      // value={item.leanderDecision.selectedType}
                    >
                      {rejectReasons?.map((item) => (
                        <Radio
                          key={item.key}
                          value={item.key}
                          onChange={() => {
                            onChangeRejectionReason(item);
                          }}
                        >
                          {item.value}
                        </Radio>
                      ))}
                      {/* <Radio value={1}>Reasone 1</Radio>
                      <Radio value={2}>Reasone 2</Radio>
                      <Radio value={3}>Reasone 3</Radio> */}
                    </Radio.Group>
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Button
                    loading={loadingCloseCase}
                    type="primary"
                    htmlType="submit"
                    className="next-btn dynamic-btn-primary"
                    style={btnPrimaryStyles}
                  >
                    Submit
                  </Button>
                </Col>
              </Row>
            </Form>
          </div>
        </Modal>
      )}

      {showAdditionalFields ? (
        <Title level={4}>
          <Button
            type="link"
            style={{ border: "none", background: "transparent" }}
            onClick={() => {
              setShowAdditionalFields(false);
            }}
          >
            <span style={{ color: "#1890ff", fontSize: "20px" }}>
              View Lead
            </span>
          </Button>
          &nbsp; &gt; &nbsp;Additional Fields For {selectedLander?.lenderName}
        </Title>
      ) : showApplicantInfo ? (
        <>
          <Title level={4}>Applicant Information</Title>
        </>
      ) : showMultilenderOffer ? (
        <Title level={4}>
          {/* <Link className="link" to={"/lead"}> */}

          <Row>
            <Col xs={24} xl={16} span={16}>
              <div
                className=""
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    fontSize: "24px",
                    fontWeight: "350",
                  }}
                >
                  Bureau Based Offers
                </span>
                <span>
                  <Button
                    key=""
                   className="back-icon-btn"
                   style={btnPrimaryStyles}
                    onClick={() => setShowMultiLenderOffer(false)}
                  >
                    <Back_Arrow />
                    {/* <img
                      src={back_arrow}
                      width={15}
                      height={15}
                      style={{ margin: "0px 5px 0px 5px" }}
                    /> */}
                    Back
                  </Button>
                </span>
              </div>
            </Col>
          </Row>

          {/* </Link> */}
          {/* &nbsp; &gt; &nbsp;View Lead */}
        </Title>
      ) : (
        <></>
      )}

      {showAdditionalFields ? (
        <AdditionalField
          setCustomUI={setCustomUI}
          setLeadData={setLeadData}
          currLenderId={currLenderId}
          currLoanProductId={currLoanProductId}
          currLeadId={currLeadId}
          customUI={customUI}
          selectedLander={selectedLander}
          leadData={leadData}
          additionalFields={additionalFields ? additionalFields : []}
          setShowAdditionalFields={setShowAdditionalFields}
          callbackAdditionalField={setCallbackAdditionalField}
          setFaircentStatus={setFaircentStatus}
          taskDetails={taskDetails}
          formData={formData ?? {}}
          setIsLastTask={setIsLastTask}
          isLastTask={isLastTask}
          setAdditionalFields={setAdditionalFields}
          setTaskDetails={setTaskDetails}
          getLeadById={getLeadById}
          callBackRejected={(callBackData) => {
            getLeadById();
            const status = callBackData?.status ?? "";
            if (
              status.length > 0 &&
              ["rejected"].includes(status.toLowerCase())
            ) {
              setTimeout(() => {
                setShowRequirementDocs(false);
                setLanderDecisionActive(true);
                nextStage("lenderDecision");
                setLoading(false);
                notification.error({ message: callBackData?.Message });
              });
            }
          }}
          callBack={() => {
            getLeadById();
          }}
          lenderLoginHandler={lenderLoginHandler}
          skippedLoginStatus={skippedLoginStatus}
        />
      ) : showApplicantInfo ? (
        <>
          <ApplicantInformation
            isGetBureauScore={true}
            setShowApplicantInfo={setShowApplicantInfo}
            setIsApplicantModal={setIsApplicantModal}
            leadData={leadData}
            getBureauScore={getBureauScore}
            genrateBureauScore={genrateBureauScore}
            getLeadById={getLeadById}
          />
        </>
      ) : showMultilenderOffer ? (
        <Row>
          <Col xs={24} xl={16} span={16}>
            <MultiLenderOfferScreen leadData={leadData} />
          </Col>
        </Row>
      ) : (
        <Row gutter={[16, 16]}>
          <Col xs={24} xl={8} span={8}>
            {topView()}

            <div
              className="lead-detail-box"
              style={{ height: "calc(100% - 75px)" }}
            >
              <div className="heading">
                <Title level={5}>Lead Information</Title>
                <Button onClick={() => setCloseCase(true)} type="default" className="dynamic-btn-default" style={btnDefaultBorderStyle}>
                  Close Case
                </Button>
                <Space
                  className="action-button"
                  size="small"
                  style={{ marginRight: "-6px", marginLeft: "3px" }}
                >
                  <Button
                    size="small"
                    hidden={!leadData?.isWhatsAppEnabled}
                    onClick={() => {
                      handleClick();
                    }}
                    icon={
                      <img
                        src={whatsappIcon}
                        alt=""
                        width={24}
                        height={24}
                        style={{ marginTop: "-4px" }}
                      />
                    }
                  />
                  <Button
                    size="small"
                    className="custome-btn-icon-secondary"
                    style={{'--bgColor': appColors?.appSecondaryColor ?? ""} as any}
                    type="text"
                    // hidden={selectedPreCase === "LEAD" && activeKey === "1"}
                    onClick={() => getShareLinkId(leadData)}
                    icon={<IconShare width={24} height={24}/>             
                    }
                  />
                </Space>
              </div>
              <div className="lead-details">
                <Text className="source">Lead Source</Text>
                <Row gutter={[16, 16]} className="custom-row">
                  <Col>
                    <Title level={5}>
                      {
                        leadData?.caseDetails?.connectorDetails?.userDetails
                          ?.fullName
                      }
                    </Title>
                    <Text>
                      {
                        leadData?.caseDetails?.connectorDetails?.userDetails
                          ?.userId
                      }
                    </Text>
                    <br />
                    <Text>
                      {leadData?.caseDetails?.connectorDetails?.address?.state}
                    </Text>
                  </Col>
                  {payoutType !== "FIXED" && (
                    <Col>
                      <Text>Tentative Payout %</Text>
                      <br />
                      <Title level={5}>{tentativePayout}</Title>
                    </Col>
                  )}
                </Row>
              </div>
              <div className="lead-details">
                <Row gutter={[16, 16]} className="custom-row">
                  <Col className="custom-row">
                    <Text className="title">Applicant Type</Text>
                    <br />
                    <Text>{leadData?.applicationType}</Text>
                  </Col>
                  <Col>
                    <Text className="title">
                      {leadData?.applicationType != null
                        ? leadData?.applicationType + " Type"
                        : null}
                    </Text>
                    <br />
                    <Text>{leadData?.applicationSubType}</Text>
                  </Col>
                  <Col>
                    <Text className="title">Gender</Text>
                    <br />
                    <Text>{leadData?.contactDetails?.gender}</Text>
                  </Col>
                </Row>

                <Row className="custom-row">
                  <Col className="custom-row">
                    <Space direction="vertical" className="gap">
                      <Text className="title">Applicant Details</Text>
                      <Text>{leadData?.contactDetails?.firstName}</Text>
                      {(leadData?.contactDetails?.dateOfBirth?.length ?? 0) !==
                        0 && (
                        <Text>
                          {moment(leadData?.contactDetails.dateOfBirth)
                            .locale("en")
                            .format("DD MMM YYYY")}
                        </Text>
                      )}
                      <Text>{leadData?.contactDetails?.emailId}</Text>
                      <Text>
                        {leadData?.contactDetails?.mobileNumber.startsWith("1")
                          ? ""
                          : getMaskedMobile(userRolePermission["MaskMobileNumber"], leadData?.contactDetails?.mobileNumber)}
                      </Text>
                    </Space>
                  </Col>
                  <Col>
                    <Space direction="vertical" className="gap">
                      <Text className="title">Current Address</Text>
                      <Text>{leadData?.address?.pinCode}</Text>
                      <Text>{leadData?.address?.address}</Text>
                      <Text>{leadData?.address?.city}</Text>
                      <Text>{leadData?.address?.state}</Text>
                      <Text>{leadData?.address?.country}</Text>
                    </Space>
                  </Col>
                </Row>
              </div>
              <div className="lead-details">
                <Row className="custom-row">
                  {leadData?.loanType == "Education Loan" ? (
                    <Space direction="vertical" className="gap">
                      <Text className="title">Additional Details</Text>
                      <Text>
                        PAN:{" "}
                        {leadData?.contactDetails?.pan === "PENDING"
                          ? ""
                          : leadData?.contactDetails?.pan}
                      </Text>
                    </Space>
                  ) : (
                    <Space direction="vertical" className="gap">
                      <Text className="title">Additional Details</Text>
                      <Text>
                        PAN:{" "}
                        {leadData?.contactDetails?.pan === "PENDING"
                          ? ""
                          : leadData?.contactDetails?.pan}
                      </Text>
                      <Text>
                        Company: {leadData?.entityOrEmployerName || "NA"}
                      </Text>

                      {leadData?.loanType === "Personal Loan" ||
                      (leadData?.loanType?.toLowerCase() === "home loan" &&
                        leadData?.applicationSubType == "Salaried") ? (
                        <>
                          <Text>
                            Monthly In-hand Salary: Rs.
                            {numberWithCommas(
                              leadData?.caseDetails?.loanDetails
                                ?.monthlyInHandSalary
                            )}
                          </Text>
                          <Text>
                            Current EMIs: Rs.
                            {numberWithCommas(
                              leadData?.caseDetails?.loanDetails?.currentEmis
                            )}
                          </Text>
                        </>
                      ) : (
                        <>
                          <Text>Business Profile: {getBusinessProfile()}</Text>
                          <Text>
                            {/* Business Vintage is displayed as No of Years In Business as per Figma design 02-02-2023*/}
                            No of Years In Business:{" "}
                            {leadData?.businessVintage
                              ? leadData?.businessVintage
                              : 0}
                          </Text>
                          <Text>
                            Business Turnover (Yearly): Rs.
                            {leadData?.businessTurnOver
                              ? numberWithCommas(leadData?.businessTurnOver)
                              : 0}
                          </Text>
                          <Text>
                            Monthly Obligations (EMIs): Rs.
                            {leadData?.monthlyEmi
                              ? numberWithCommas(leadData?.monthlyEmi)
                              : 0}
                          </Text>
                          <Text>Ownership: {getPropertyOwnership()}</Text>
                        </>
                      )}
                    </Space>
                  )}
                </Row>
              </div>
              {leadData?.loanType == "Education Loan" && (
                <div className="lead-details">
                  <Row className="custom-row">{renderEducationDetails()}</Row>
                </div>
              )}
              {lenderDetailFibe.length === 0 &&
              Object.keys(basicOfferDetails).length > 0 ? (
                <div className="lead-details">
                  <Row className="custom-row">
                    <Space direction="vertical" className="gap">
                      <Text className="title">Basic Offer Details</Text>
                      <Text>
                        Offered Loan Amount: Rs.{" "}
                        {numberWithCommas(
                          basicOfferDetails?.maxAllowedLoanAmount ??
                            basicOfferDetails?.loanAmount ??
                            0
                        )}
                      </Text>
                      <Text>
                        ROI:{" "}
                        {basicOfferDetails?.interest ??
                          basicOfferDetails?.roi ??
                          0}
                        %
                      </Text>
                      <Text>
                        EMI: Rs.{" "}
                        {numberWithCommas(
                          basicOfferDetails?.totalEMI ??
                            basicOfferDetails?.emi ??
                            0
                        )}
                      </Text>
                      <Text>
                        Tenure:{" "}
                        {basicOfferDetails?.tenureInMonths ??
                          basicOfferDetails?.tenure ??
                          0}
                      </Text>
                    </Space>
                  </Row>
                </div>
              ) : (
                <>
                  {lenderDetailFibe.length > 0 &&
                  Number(lenderDetailEarlySalary?.sanctionLimit) > 0 ? (
                    <div className="lead-details">
                      <Row className="custom-row">
                        <Space direction="vertical" className="gap">
                          <Text className="title">Basic Offer Details</Text>
                          <Text>
                            Offered Loan Amount: Rs.{" "}
                            {numberWithCommas(
                              Number(lenderDetailEarlySalary?.sanctionLimit)
                            )}
                          </Text>
                        </Space>
                      </Row>
                    </div>
                  ) : null}
                </>
              )}

              {/* {(basicOfferDetails === null && lenderDetailCashe && lenderDetailCashe?.at(0)?.status === "SANCTIONED") ?
                      <div className="lead-details">
                        <Row className="custom-row">
                          <Space direction="vertical" className="gap">
                            <Text className="title">Basic Offer Details</Text>
                            <Text>Offered Loan Amount: Rs. {numberWithCommas(Number(lenderDetailCashe?.at(0)?.sanctionedAmount))}</Text>
                          </Space>
                        </Row>
                      </div>
                      :
                      null
                    } */}
              <div className="lead-details">
                <Row className="custom-row" gutter={[16, 16]}>
                  <Col>
                    <Space direction="vertical" className="gap">
                      <Text className="title">Loan Details</Text>
                      <Text>
                        Loan Amount: Rs.
                        {leadData?.caseDetails?.loanDetails?.loanAmount &&
                          numberWithCommas(
                            leadData?.caseDetails?.loanDetails?.loanAmount
                          )}{" "}
                      </Text>
                      <Text>
                        Loan Tenure:{" "}
                        {leadData?.caseDetails?.loanDetails?.loanTenureInYears}{" "}
                        Years
                      </Text>
                    </Space>
                  </Col>
                  <Col>
                    <Space direction="vertical" className="gap">
                      <Text className="title">Loan Type</Text>
                      <Text>{leadData?.loanType}</Text>
                    </Space>
                  </Col>
                </Row>
              </div>
              {/* TODO: Bureau Score */}
              {/* <div style={{ paddingInline: "12px" }}>
                <BureauScoreView
                  status={
                    leadData?.leadAdditionalInfoDetails?.bureauScoreStatus ?? ""
                  }
                />
              </div> */}
            </div>
          </Col>
          {showRequirementDocs ? (
            <Col xs={24} xl={16} span={16}>
              <RequiredDocuments
                selectedLander={selectedLander}
                leadData={leadData}
                setShowRequirementDocs={setShowRequirementDocs}
                callBackDoc={(data) => {
                  console.log("callBackDoc ---- ", data);
                  setCallbackReqDoc(data);
                  if (
                    selectedLander?.lenderName?.toLowerCase()?.includes("fibe")
                  ) {
                    getLeadById();
                    const status =
                      (callbackAdditionalField as any)?.earlySalaryResponse
                        ?.status ?? "";
                    if (
                      status.length > 0 &&
                      !["Suspended", "Success"].includes(status)
                    ) {
                      setTimeout(() => {
                        setLanderDecisionActive(true);
                        nextStage("lenderDecision");
                        setLoading(false);
                      }, 1000);
                    }
                  } else {
                    const lender =
                      leadData?.caseDetails?.lenderActivityHolder?.lenderActivityDetails?.find(
                        (lItem) => lItem.lenderInfoId === data.lenderInfoId
                      );
                    if (lender && lender?.status === "LOGGED") {
                      skippedLoginStatus();
                    } else {
                      skippedLoginStatus();
                      // lenderLoginHandler({comment: null,assignedLenderFiltered: [selectedLander],});
                    }
                  }
                }}
              />
            </Col>
          ) : (
            <>
              <Col xs={24} xl={8} span={8}>
                <div
                  className="lead-detail-box bre-status-box"
                  style={{ height: "auto" }}
                >
                  <div className="heading">
                    <Title level={5} style={{ width: "150px" }}>
                      BRE Status
                    </Title>
                    <div style={{ display: "grid" }}>
                      <span>Drop off Stage:</span>
                      <span style={{ overflowWrap: "break-word" }}>
                        {getEnumValue(
                          "PROSPECT_ONBOARDING_STATUS",
                          breDetails?.dropOffStage ?? ""
                        )}
                      </span>
                    </div>
                  </div>
                  <div
                    style={{
                      padding: "10px",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <div style={{ width: "200px" }}>
                      <span>Scorecard Status</span>
                      <br />
                      <span>
                        Gating Criteria:{" "}
                        {
                          breDetails?.scoreCardDetails
                            ?.gatingCriteriaScoreCardDetails?.breStatus
                        }
                      </span>
                      <br />
                      <p>
                        Reason:{" "}
                        {
                          breDetails?.scoreCardDetails
                            ?.gatingCriteriaScoreCardDetails?.rejectionReason
                        }
                      </p>
                    </div>
                    {/* <div style={{ width: "100px" }}>
                      <span>Offer Amount</span>
                      <p>
                        Rs.{" "}
                        {
                          breDetails?.scoreCardDetails
                            ?.eligibilityScoreCardDetails?.offerAmount
                        }{" "}
                      </p>
                    </div> */}
                  </div>
                  {/* <div style={{ padding: "10px" }}>
                    <span>
                      Eligibility:{" "}
                      {
                        breDetails?.scoreCardDetails
                          ?.eligibilityScoreCardDetails?.breStatus
                      }
                    </span>
                    <p>
                      Reason:{" "}
                      {
                        breDetails?.scoreCardDetails
                          ?.eligibilityScoreCardDetails?.rejectionReason
                      }
                    </p>
                  </div> */}
                  <div className="multi-lender-offer" style={{"--textColor": appColors?.appPrimaryColor ?? ""} as any}>
                    <span onClick={() => setShowMultiLenderOffer(true)} className="border-edit-icon" style={{"--borderColor": appColors?.appPrimaryColor ?? ""} as any}>
                          <IconArrowBorder height={17} width={17}/>&nbsp;
                        Multilender Offers
                    </span>
                  </div>
                </div>
                <div className="lead-detail-box" style={{ height: "auto" }}>
                  
                  <div className="heading" >
                    <Title level={5}>History</Title>
                  </div>
                  <Row className="timeline" >
                    <Col span={24}>
                      <Timeline>
                        {leadHistory?.map((item: any, i: number) => (
                          <Timeline.Item
                            className="timeline-box"
                            key={i}  
                            color={appColors?.appSecondaryColor ?? "#c71c8e"} style={{'--color': appColors?.appSecondaryColor ?? ""}as any} 
                          >
                            <Title level={4} style={{display: isMobile ? "grid" : "flex"}}>
                              {item?.currentStatus && (
                                <span style={{fontWeight:'750'}}>{item?.currentStatus}</span>
                              )}
                              {item.statusChangedOn && (
                                <span className="date">
                                  {moment(item.statusChangedOn)
                                    .locale("en")
                                    .format("DD MMM YYYY hh:mm A")}
                                </span>
                              )}
                            </Title>
                            <Title level={5} style={{fontSize:'12px' ,fontWeight:'400'}}>
                              {item?.changedByUser?.firstName}
                            </Title>
                            {(item?.comments || item?.statusUpdate) && (
                              <>
                                <Text className="title">Comment:</Text>
                                <br />
                                <Text style={{fontSize:'12px' ,fontWeight:'400'}}>{item?.comments}</Text>
                                {item?.statusUpdate &&
                                  renderStatusupdate(item?.statusUpdate)}
                              </>
                            )}
                          </Timeline.Item>
                        ))}
                      </Timeline>
                    </Col>
                  </Row>
                </div>
              </Col>
              <Col xs={24} xl={8} span={8}>
                <div className="lead-detail-box">
                  <div className="heading">
                    <Title level={5}>Current Stage</Title>
                    <div className="menu-list">
                      <Dropdown overlay={menuList} placement="topRight" arrow>
                        <Space>
                          Go To
                          <DownOutlined />
                        </Space>
                      </Dropdown>
                    </div>
                  </div>
                  <div className="details-item">
                    <Tabs
                      className={`custom-tab ${showVas ? " tab-3" : ""}`}
                      style={tabStyles}
                      // className='custom-tab'
                      defaultActiveKey="1"
                      onChange={changeStage}
                      activeKey={activePanel}
                    >
                      <Tabs.TabPane tab="Current Stage" key="1">
                        {currentStage.lenderSelection && (
                          <LenderSelection
                            leadData={leadData}
                            lenderNextHandler={lenderNextHandler}
                            loadingUpdate={loadingUpdate}
                          />
                        )}
                        {currentStage.login && selectedLenderList && (
                          <LenderLogin
                            skippedLoginStatus={skippedLoginStatus}
                            setCustomUI={setCustomUI}
                            leadData={leadData}
                            loading={loading || loadingUpdate}
                            setCurrLeadId={setCurrLeadId}
                            setCurrLoanProductId={setCurrLoanProductId}
                            setCurrLenderId={setCurrLenderId}
                            setShowRequirementDocs={setShowRequirementDocs}
                            setTaskDetails={setTaskDetails}
                            setShowAdditionalFields={setShowAdditionalFields}
                            setAdditionalFields={setAdditionalFields}
                            setFormData={setFormData}
                            setSelectedLander={setSelectedLander}
                            assignedLenders={selectedLenderList}
                            lenderLoginHandler={lenderLoginHandler}
                            callbackAdditionalField={callbackAdditionalField}
                            callbackReqDoc={callbackReqDoc}
                            setCallbackAdditionalField={
                              setCallbackAdditionalField
                            }
                            setCallbackReqDoc={setCallbackReqDoc}
                            getRedirectURLLink={getRedirectURLLink}
                            getDownloadLetterForICICI={
                              getDownloadLetterForICICI
                            }
                            setIsLastTask={setIsLastTask}
                            isLastTask={isLastTask}
                            currLeadId={currLeadId}
                            currLenderId={currLenderId}
                            getCashETriggerSMSLink={getCashETriggerSMSLink}
                          />
                        )}
                        {currentStage.lenderDecision && (
                          <LenderDecision
                            faircentStatus={faircentStatus}
                            leadData={leadData}
                            assignedLenders={selectedLenderList}
                            lenderDecisionHandler={lenderDecisionHandler}
                            getRedirectURLLink={getRedirectURLLink}
                            getDownloadLetterForICICI={
                              getDownloadLetterForICICI
                            }
                            loadingUpdate={loadingUpdate}
                            getCashETriggerSMSLink={getCashETriggerSMSLink}
                          />
                        )}
                        {currentStage.disbursed && (
                          <LenderDisbursed
                            leadData={leadData}
                            assignedLenders={selectedLenderList}
                            lenderDisbursedHandler={lenderDisbursedHandler}
                            getRedirectURLLink={getRedirectURLLink}
                            getDownloadLetterForICICI={
                              getDownloadLetterForICICI
                            }
                            loadingUpdate={loadingUpdate}
                            getCashETriggerSMSLink={getCashETriggerSMSLink}
                          />
                        )}
                        {currentStage.visit && (
                          <>
                            <Title level={5}>Visit</Title>
                            <Title level={5}>Comment:</Title>
                            <Form.Item name="visitComment">
                              <TextArea
                                defaultValue={
                                  leadData?.caseDetails?.caseHistoryHolder
                                    ?.visitState[0]?.comments
                                }
                                placeholder="Comment"
                                onChange={(e) => setUserComment(e.target.value)}
                                rows={4}
                              />
                            </Form.Item>
                            <Space className="btn-space">
                              <Button
                                onClick={() => {
                                  nextStage("DOCUMENTATION");
                                }}
                                type="default"
                                className="dynamic-btn-default"
                                style={btnDefaultBorderStyle}
                              >
                                Skip
                              </Button>
                              <Button
                                onClick={() => {
                                  // nextStage("DOCUMENTATION");
                                  visitNextHandler();
                                }}
                                type="primary"
                                className="dynamic-btn-primary"
                                style={btnPrimaryStyles}
                              >
                                Next Step
                              </Button>
                            </Space>
                          </>
                        )}
                        {currentStage.prospect && (
                          <>
                            <Title level={5}>Prospect</Title>
                            <Title level={5}>Comment:</Title>

                            <TextArea
                              placeholder="Comment"
                              value={userProspectComment}
                              onChange={(e) =>
                                setUserProspectComment(e.target.value)
                              }
                              rows={4}
                            />
                            <Space className="btn-space"></Space>
                            <Space className="btn-space">
                              <Form.Item name="cancel">
                                <Button
                                  onClick={() => {
                                    history.push("/lead");
                                  }}
                                  type="default"
                                  className="dynamic-btn-default"
                                  style={btnDefaultBorderStyle}
                                >
                                  Cancel
                                </Button>
                              </Form.Item>
                              <Form.Item name="submit">
                                <Button
                                  className="dynamic-btn-primary"
                                  style={btnPrimaryStyles}
                                  onClick={() => {
                                    prospectSubmitHandler();
                                  }}
                                  type="primary"
                                >
                                  Next Stage
                                </Button>
                              </Form.Item>
                            </Space>
                          </>
                        )}
                      </Tabs.TabPane>
                      <Tabs.TabPane tab="Documents" key="2">
                        {
                          <DocumentationList
                            leadData={leadData}
                            lenderDocumentHandler={lenderDocumentHandler}
                          />
                        }
                      </Tabs.TabPane>
                      {showVas ? (
                        <Tabs.TabPane tab="VAS" key="3">
                          <GetBureau
                            leadData={leadData}
                            getBureauScore={getBureauScore}
                            genrateBureauScore={genrateBureauScore}
                            bureauColor={bureauColor}
                            consetObj={consetObj}
                            bureauScoreStatus={bureauScoreStatus}
                            setShowApplicantInfo={setShowApplicantInfo}
                            isApplicantModal={isApplicantModal}
                            setIsApplicantModal={setIsApplicantModal}
                          />
                        </Tabs.TabPane>
                      ) : null}
                    </Tabs>
                  </div>
                </div>
              </Col>
              {whatsapp()}
              {message()}
            </>
          )}
        </Row>
      )}
    </div>
  );
};

export default LeadDetails;
